import React from "react";
import Hero from "../sections/Hero";
import Features from "../sections/Features";
import Rooms from "../sections/Rooms";
import Testimonials from "../sections/Testimonials";
import Contact from "../sections/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Features />
      <Rooms />
      <Testimonials />
      <Contact />
    </>
  );
}
